import clsx from "clsx";

import "./background.scss";

export const AILayoutBackground = ({ children, className }) => {
  return (
    <div className={clsx("ai-background", className)}>
      <div className="ai-background-dot"></div>
      {children}
    </div>
  );
};
